import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src="/assets/icon.png" alt="IN-It app icon" className="w-11 h-11 rounded-xl" />
              <span className="font-display font-extrabold text-xl text-white">IN-IT</span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-xs">
              The live social streaming app. Every moment is temporary — being there is what stays.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 mb-4">CONTACT</p>
            <a data-testid="footer-info-email" href="mailto:info@in-itapp.com" className="block text-sm text-zinc-300 hover:text-ink-cyan transition-colors duration-200 mb-2">info@in-itapp.com</a>
            <a data-testid="footer-report-email" href="mailto:report@in-itapp.com" className="block text-sm text-zinc-300 hover:text-ink-ember transition-colors duration-200">report@in-itapp.com</a>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 mb-4">HQ</p>
            <p data-testid="footer-hq-address" className="text-sm text-zinc-300 leading-relaxed">
              Lodjurstråket 1<br />417 51 Gothenburg<br />Sweden
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-500 mb-4">LEGAL</p>
            <Link to="/privacy" data-testid="footer-privacy-link" className="block text-sm text-zinc-300 hover:text-white transition-colors duration-200 mb-2">Privacy Policy</Link>
            <button onClick={() => scrollToId("#contact")} data-testid="footer-contact-link" className="block text-sm text-zinc-300 hover:text-white transition-colors duration-200">Contact & Report</button>
          </div>
        </div>

        <div className="select-none pointer-events-none font-display font-extrabold text-center leading-[0.8] text-[22vw] text-white/[0.04] tracking-tighter -mb-[3vw]">
          IN-IT
        </div>

        <div className="relative flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 border-t border-white/5">
          <p data-testid="footer-copyright" className="font-mono text-xs tracking-[0.2em] text-zinc-400">© 2026 IN-ITAPP. ALL RIGHTS RESERVED.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] text-zinc-600">IN-ITAPP.COM — MADE IN GOTHENBURG</p>
        </div>
      </div>
    </footer>
  );
};
